import { db2 } from "../../../firebase";
import { addDoc, doc, collection, onSnapshot } from "firebase/firestore";
import getStripe from "./stripe";
import backlinkPost from "../../../Apis/backlink/Post";
import { getAPIUrlBM } from "../../../utils/config";
import backLinkgetCall from "../../../Apis/backlink/Get";

const url = getAPIUrlBM();

const createStripeCustomer = async () => {
  try {
    await backLinkgetCall(`${url}/payment/createCustomer`);
  } catch (err) {
    console.log(err);
  }
};

const createCheckoutSession = async (
  priceId,
  trial,
  setLoading,
  qty,
  success_url,
) => {
  //   // Create a new checkout session in the subollection inside this users document
  // console.log(navigator.language, "window.location");
  console.log(trial, "trial");
  const docRef = await doc(
    db2,
    "stripe-customers",
    localStorage.getItem("userid"),
  );
  const colRef = await collection(docRef, "checkout_sessions");
  const refss = await addDoc(colRef, {
    // replace the price_XXX value with the correct value from your product in stripe.
    price: priceId,
    success_url:
      success_url || "https://www.backlinkchecker.info/payment-confirmation",
    cancel_url: window.location.origin + "/backlink/pricing",
    allow_promotion_codes: true,
    tax_id_collection: {
      enabled: true,
    },
    trial_from_plan: trial || false,

    quantity: qty || 1,
    // coupon: "APPSUMO30",
  });
  // Wait for the CheckoutSession to get attached by the extension

  onSnapshot(refss, async (res) => {
    const newData = res.data();
    if (newData.sessionId) {
      const stripe = await getStripe();
      setLoading(false);
      // console.log(newData.sessionId, "newData.sessionId");
      stripe.redirectToCheckout({ sessionId: newData.sessionId });
    }
  });
};

const manageSubscription = async (setLoading) => {
  try {
    setLoading(true);
    const url = getAPIUrlBM();
    const response = await backLinkgetCall(
      `${url}/payment/createBillingSession`,
    );
    // console.log({ urlLogin: `${url}/createBillingSession`, response })
    setLoading(false);
    if (response.url) {
      window.open(response.url, "_blank");
    }
  } catch (e) {
    console.log(e);
  }
};

const handleUpgrade = async (priceId, setLoading) => {
  const response1 = await backlinkPost(`${url}/payment/upgradePlan`, {
    priceId,
  });
  console.log(response1);
  if (response1?.message === "success") {
    // window.sweet({
    //   title: "Success",
    //   text: "Your plan upgrade request has been generated. Please open your Billing Portal for confirming the payment.",
    //   icon: "success",
    // });
    setLoading(false);
    window.location.href = response1.invoiceUrl;
    // window.location.reload();

    // window.location = response1?.url;
    // window.open(response1?.checkoutSession.url, "_blank");
  } else if (response1?.message === "No active subscription found") {
    await createCheckoutSession(priceId, false, setLoading);
  }
};

const endUserTrail = async () => {
  const response1 = await backLinkgetCall(`${url}/payment/endusertrailnow`);
  console.log({ response1 });
  if (response1?.message === "success") {
    // window.sweet({
    //   title: "Success",
    //   text: "Your trial has ended and your plan upgrade request has been generated.\nPlease open your Billing Portal for confirming the payment..",
    //   icon: "success",
    // });
    window.location.href = response1.invoiceUrl;
    // window.location.reload();

    // window.location = response1?.url;
    // window.open(response1?.checkoutSession.url, "_blank");
  }
};

export {
  createStripeCustomer,
  createCheckoutSession,
  manageSubscription,
  handleUpgrade,
  endUserTrail,
};
